import { useContext, useMemo } from "react";

import TableContext from "context/table/tableContext";
import {
    DEVICE_DETAILS_TASK_QUEUE_COLUMNS as COLUMNS,
    FILTER_NAMES,
    ID_TYPE,
    TABLE_NAMES,
    TABLE_NAMES_WITH_FILTERS,
    usePermissions
} from "shared";

import TaskDetails from "../../../Actions/dialogs/Tasks/TaskDetails";
import { useTaskInlineActions } from "../../../Actions/InlineActions";
import Table from "../../../Table";

const TaskQueue = () => {
    const { detailsData } = useContext(TableContext);

    const { inlineActions, taskData, isOpen, closeDialog, setTaskData } =
        useTaskInlineActions();

    const { isReadTaskNotAllowed } = usePermissions();

    const { imei } = detailsData;

    const innerTableQueryParams = useMemo(
        () => ({
            [FILTER_NAMES.DeviceImei]: imei
        }),
        [imei]
    );

    return (
        <>
            <Table
                name={TABLE_NAMES.Tasks}
                nameForFilters={TABLE_NAMES_WITH_FILTERS.DeviceDetailTasks}
                hasNoPermissionToRead={isReadTaskNotAllowed}
                isInnerTable
                hideSearch
                initialColumns={COLUMNS}
                inlineActions={inlineActions}
                idType={ID_TYPE.Id}
                sortFromNewest
                innerTableQueryParams={innerTableQueryParams}
            />

            <TaskDetails
                data={taskData}
                isOpen={isOpen}
                close={closeDialog}
                setTaskData={setTaskData}
            />
        </>
    );
};

export default TaskQueue;
